import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { ImageWithArtDirection } from 'src/components/ui/Image'
import Link from 'src/components/ui/Link'
import imagesConf from 'src/images/config'

import type { ClubInformationProps } from './club-information'
import './clubInformation.scss'

function ClubInformation({ desktop, mobile }: ClubInformationProps) {
  const { isMobile } = useBreakpoint()
  const deviceData =
    typeof isMobile === 'undefined'
      ? mobile[0]
      : isMobile
      ? mobile[0]
      : desktop[0]

  const { marginTop } = deviceData
  const { marginBottom } = deviceData

  const content = (
    <>
      <div className="information__img">
        {/* <img src={deviceData.src} alt={deviceData.alt} /> */}
        <ImageWithArtDirection
          desktop={{
            baseUrl: desktop[0].src,
            ...imagesConf['carousel.desktop'],
          }}
          mobile={{
            baseUrl: mobile[0].src,
            ...imagesConf['carousel.mobile'],
          }}
          alt={deviceData.alt}
          objectFit="cover"
          loading="eager"
        />
      </div>
      <div className="information__section">
        <p className="information__title">{deviceData.title}</p>
        <p className="information__text">{deviceData.text}</p>
        <div className="information__link">
          {!isMobile && (
            <Link as="a" href={desktop[0].href}>
              <button className="information__button">
                <p>{desktop[0].buttontext}</p>
              </button>
            </Link>
          )}
        </div>
      </div>
    </>
  )

  return (
    <>
      <div
        className="information"
        style={{
          marginTop: `${marginTop ?? '24px'}`,
          marginBottom: `${marginBottom ?? '24px'}`,
        }}
      >
        {!isMobile && content}
        {isMobile && (
          <Link as="a" href={mobile[0].href}>
            {content}
          </Link>
        )}
      </div>
    </>
  )
}

export default ClubInformation
